/**
 * @bref    Fonctionnalitées jQuery relatives au téléversement de fichiers.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// Drag and drop files
//#####################################################

// Remove upload file when click on remove button
$(document).on('click', 'button.delete_files', function(event) {
    event.stopPropagation();
    if ($(this).parents('.display-upload-files').children('.input-group').length <= 1) {
        $(this).parents('.display-upload-files').removeClass('open');
    }
    $(this).parents('.input-group').remove();
});

$('.file-input').on('change', function(event) {
    event.stopPropagation();
    // Dropping files
    if (event.target.files) {
        let upload = $('<input class="form-control" type="file" name="upload[]" multiple>').prop('files', event.target.files);
        let delete_files = $('<button type="button" class="btn btn-primary btn-sm delete_files"><i class="bi bi-trash-fill"></i></button>');
        var add_upload_file = $('<div class="col-12 py-2 input-group"></div>').append(upload).append(delete_files);
        $('.display-upload-files').append(add_upload_file).addClass('open');
    }
});
